/* eslint-disable react/prefer-es6-class */
import React from 'react';
import Formsy from 'formsy-react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

export default createReactClass({
  mixins: [Formsy.Mixin],
  displayName: 'Input',

  propTypes: {
    allowedInput: PropTypes.instanceOf(RegExp),
    autoComplete: PropTypes.string,
    inputMode: PropTypes.string,
    maxLength: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    title: PropTypes.string,
    labelClassName: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]),
    validations: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
    ]),
    validationError: PropTypes.string,
    validationErrors: PropTypes.object,
    updateValue: PropTypes.func,
    min:PropTypes.string,
  },

  componentDidMount() {
    this.setValue(this.props.setValue);
  },

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.setValue && nextProps.setValue !== this.props.setValue) {
      this.setValue(nextProps.setValue);
    }
  },

  getInitialState: function () {
    return { errorMsg: ''};
  },

  changeValue: function (event) {
    event.stopPropagation();
    const setValueFunction = event.type === 'change' ? this.mySetValue : this.setValue;
    const value = this.getTargetValue(event.target);

    if (this.props.onChange && event.type === 'change') {
      this.props.onChange(event, value);
    }

    const newValue = this.props.updateValue ? this.props.updateValue(value) : value;
    const newChar = newValue[newValue.length - 1];

    const notAllowedValues = this.notAllowedValues(value);
    // if newChar isn't allowed, set value to the old value to re-render the component
    if (newChar && newValue === value && notAllowedValues.length && !this.props.updateValue) {
      const splitValue = this.removeInvalidChars(value, notAllowedValues);
      setValueFunction(splitValue);
    } else {
      setValueFunction(newValue);
    }
  },

  removeInvalidChars(values, notAllowedValues) {
    return notAllowedValues.reduce((total, notAllowedValue) => {
      return this.removeInvalidChar(total, notAllowedValue);
    }, values);
  },

  removeInvalidChar(values, value) {
    const index = values.indexOf(value);
    return values.slice(0, index) + values.slice(index + 1, values.length);
  },

  notAllowedValues(values) {
    if (!this.props.allowedInput) return [];
    return values.split('').filter((value) => !this.props.allowedInput.test(value));
  },

  mySetValue: function (value) {
    if(this.getErrorMessage() != null){
      this.setValue(value);
    }
    else{
      if (this.isValidValue(value)) {
        this.setValue(value);
      }
      else{
        this.setState({
          _value: value,
          _isPristine: false,
        });
      }
    }
  },

  getClassName: function () {
    return 'form-group ' +
           (this.props.className || '') +
           (this.isRequired() ? ' required' : '') +
           (this.showError() ? ' error' : '');
  },

  getTargetValue(target) {
    if (this.props.type === 'checkbox') {
      return target['checked'] ? '1' : '0';
    } else {
      return target['value'];
    }
  },

  getDefaultValue() {
    return this.props.type === 'checkbox' ? '0' : '';
  },

  render: function () {
    const className = this.getClassName();
    const errorMessage = this.getErrorMessage();
    const errorClass = errorMessage ? 'active' : '';
    return (
      <div className={className}>
        <input
          aria-label={this.props.title}
          className={this.props.inputLabelClassName}
          autoComplete={this.props.autoComplete}
          checked={this.props.type === 'checkbox' && this.getValue() === '1' ? true : false}
          id={this.props.name}
          inputMode={this.props.inputMode}
          maxLength={this.props.maxLength}
          name={this.props.name}
          onBlur={this.changeValue}
          onChange={this.changeValue}
          placeholder={this.props.placeholder}
          type={this.props.type || 'text'}
          value={this.getValue() || this.getDefaultValue()}
          disabled={this.props.disabled}
          min={this.props.min}
        />
        <label className={this.props.inputLabelClassName} htmlFor={this.props.name}>{this.props.title}</label>
        <span className={`${errorClass} validation-error`}>{errorMessage}</span>
      </div>
    );
  },
});
